export class CertificateTypeDTO{
    id!: number;
    name?: string;
    standard:any[]=[];
    sortOrder?: number;
}